import { useEffect } from 'react';
import {
    Avatar, Form, Input, Row, Col,
    Button,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { IUserInfo } from '../hooks/useUser';
import { useForm } from '../hooks/useForm';
import { useFetch } from '../hooks/useFetch';

interface IClientInfoProps {
    data?: IUserInfo;
}

function ClientInfo({ data }: IClientInfoProps) {
    const api = useFetch();
    const [form] = useForm();
    const { t } = useTranslation();

    useEffect(() => {
        form.setFieldsValue(data);
    }, [data]);

    const onFinish = (values: Record<string, any>) => {
        api.request({
            url: `/clients/${data?.id}/update`,
            method: 'post',
            data: { email: values.email, phone: values.phone },
        });
    };

    return (
        <Row gutter={[20, 20]}>
            <Col xs={24} md={6}>
                <div className="d-flex justify-content-center">
                    <Avatar
                        src={data?.photo}
                        size={120}
                    />
                </div>
            </Col>
            <Col xs={24} md={18}>
                <Form form={form} layout="vertical" onFinish={onFinish}>
                    <Row gutter={10}>
                        <Col xs={24} md={12}>
                            <Form.Item label={t('surname')} name="surname">
                                <Input readOnly />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label={t('name')} name="name">
                                <Input readOnly />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label={t('email')} name="email">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label={t('phone')} name="phone">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label={t('activeOrdersCount')} name="active_orders_count">
                                <Input readOnly />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label={t('ordersCount')} name="orders_count">
                                <Input readOnly />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Button
                        title={t('save') as string}
                        type="primary"
                        htmlType="submit"
                        loading={api.loading}
                    >
                        {t('save')}
                    </Button>
                </Form>
            </Col>
        </Row>
    );
}

ClientInfo.defaultProps = {
    data: undefined,
};

export default ClientInfo;
